export const orderParametosInternos = (valueProceso, dataTable) => {
  switch (valueProceso) {
    case 4:
    case 35:
      return [dataTable[1], dataTable[2], dataTable[0]];
    default:
      return dataTable;
  }
};
